import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { listAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(listAnatomy.keys);

const baseStyle = definePartsStyle({
  item: {
    ml: 4,
  },
});

export const listTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
});
